import { Tag } from '@lifebit-ai/lds'
import React from 'react'
import styled from 'styled-components'

export const EXTERNAL_REQUEST_TAG_TEST_ID = 'external-request-tag'

// styled(Tag): the Tag reads its `color` prop as the background; we inject the theme's
// purple "info" background and override the text colour so it reads as a distinct accent.
const StyledExternalTag = styled(Tag).attrs(({ theme }) => ({
  color: theme?.color?.feedback?.info?.background,
  hasBorder: true
}))`
  color: ${({ theme }) => theme?.color?.feedback?.info?.default};
`

export const ExternalRequestTag = (): JSX.Element => (
  <StyledExternalTag data-testid={EXTERNAL_REQUEST_TAG_TEST_ID}>External</StyledExternalTag>
)
